<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 17:14:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/index.vue
-->
<template>
  <div class="order_detail">
    <!-- titleBar -->
    <img src="@/assets/order/mlik_plan_bg1@2x.png" alt="" class="header_bg" />
    <div class="detail_con">
      <div :style="bgStyle" class="bar_header">
        <img
          :src="opacityStyle.opacity !== 1 ? whiteGo : blackGo"
          alt=""
          class="icon_back left"
          @click="back"
        />
        <div
          :style="opacityStyle"
          class="font18 colo087 font_weight500 line_height_48"
          @click="back"
        >
          配送计划
        </div>
      </div>
      <!-- 头部信息 -->
      <div class="top_det">
        <header-det />
      </div>
      <!-- 配送时间 -->
      <div ref="addDet" class="top_address">
        <plan-week />
      </div>
      <!-- 商品信息 -->
      <div class="product_con_det">
        <!-- 商品信息 -->
        <order-product-list
          :bgPad="'bg0'"
          :item="getDistributionPlan.skuInfo"
          :pageShow="false"
          :showPrice="false"
        />
      </div>
      <!-- 配送信息 -->
      <div
        v-if="
          getDistributionPlan.unFinishList &&
            getDistributionPlan.unFinishList.length
        "
      >
        <div
          v-for="(item, index2) in getDistributionPlan.unFinishList"
          :key="index2"
          class="plan_det"
        >
          <plan-time-status :item="item" :overBg="false" />
          <address-det
            :address="item.address"
            :planDeliveredAt="item.planDeliveredAt"
            :showAt="
              getDistributionPlan.status === 0 ||
                (getDistributionPlan.status === 1 && item.status === 1)
            "
            :finished="false"
          />
          <bottom-btn
            :showLog="item.status === 2 || item.status === 1"
            :item="item"
            @lookLogist="lookLogist"
            @modifyAddress="modifyAddress"
          />
        </div>
      </div>
      <div
        v-if="
          getDistributionPlan.finishList &&
            getDistributionPlan.finishList.length
        "
      >
        <div
          v-for="(item, index2) in getDistributionPlan.finishList"
          :key="index2"
          class="plan_det"
        >
          <plan-time-status :item="item" :overBg="true" />
          <address-det
            :address="item.address"
            :planDeliveredAt="item.planDeliveredAt"
            :deliveredAt="item.deliveredAt"
            :finished="true"
          />
          <bottom-btn
            :showLog="true"
            :item="item"
            @lookLogist="lookLogist"
            @modifyAddress="modifyAddress"
          />
        </div>
      </div>
      <div
        :class="
          getDistributionPlan.status === 1
            ? 'det_none_btn'
            : showEditBtn.length === 0
            ? 'det_mar1'
            : 'det_mar'
        "
      ></div>
    </div>
    <!-- 底部修改时间按钮 -->
    <div
      v-if="getDistributionPlan.unFinishList && showEditBtn.length !== 0"
      class="bottom_btn"
    >
      <plan-btn
        @stopDate="stopDate"
        @goChooseDate="goChooseDate"
        @containDate="containDate"
      />
    </div>
    <!-- 地址弹窗 -->
    <plan-select-address
      v-if="show"
      @closeBg="closeBg"
      @goAddressList="goAddressList"
    />
  </div>
</template>
<script>
import HeaderDet from "./components/HeaderDet";
import AddressDet from "./components/AddressDet";
import OrderProductList from "../list/components/OrderProductList";
import BottomBtn from "./components/BottomBtn";
import PlanWeek from "./components/PlanWeek";
import PlanTimeStatus from "./components/PlanTimeStatus";
import PlanBtn from "./components/PlanBtn";
import PlanSelectAddress from "./components/PlanSelectAddress";
import { setTimeout } from "timers";

export default {
  name: "OrderDetail",
  components: {
    HeaderDet,
    AddressDet,
    OrderProductList,
    BottomBtn,
    PlanWeek,
    PlanTimeStatus,
    PlanBtn,
    PlanSelectAddress
  },
  data() {
    return {
      showCancel: false,
      bgStyle: {
        backgroundColor: "rgba(255,255,255," + 0 + ")"
      },
      opacityStyle: {
        opacity: 0
      },
      whiteGo: require("@/assets/common/icon_back_default_dark@2x.png"),
      blackGo: require("@/assets/common/icon_back@2x.png"),
      show: false,
      modifyOnePacel: ""
    };
  },
  computed: {
    getDistributionPlan() {
      return this.$store.getters.getDistributionPlan;
    },
    showEditBtn() {
      const { unFinishList } = this.getDistributionPlan;
      // console.log(unFinishList, "33232");
      if (unFinishList) {
        const a = unFinishList.filter(item => item.status === 0);
        // console.log(a);
        return a;
      } else {
        return [];
      }
      // console.log(a.length);
      // return a.length;
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {});
    // 修改下期配送计划
    if (localStorage.getItem("mall-wap-milkplan-choosedate")) {
      // updateDistributionPlanPlanDeliveredAt
      const params = {
        subOrderSn: this.$route.query.subOrderSn,
        planDeliveredAt: localStorage.getItem("mall-wap-milkplan-choosedate")
      };
      this.updatePlan(params);
    }
    // 修改地址  updateDistributionPlanAddress
    const oneAddress = JSON.parse(
      localStorage.getItem("exchange-milk-plan-one-address")
    );
    // console.log(localStorage.getItem("exchange-milk-plan-one-parcelId"), "id");
    // const allAddress = localStorage.getItem("exchange-milk-plan-all-address");
    const address =
      JSON.parse(localStorage.getItem("exchange-milk-plan-one-address")) ||
      JSON.parse(localStorage.getItem("exchange-milk-plan-all-address"));
    // console.log(address, "address");
    if (address) {
      let params = {
        subOrderSn: this.$route.query.subOrderSn,
        address: {
          name: address.name,
          phone: address.phone,
          province: address.province,
          city: address.city,
          district: address.district,
          addressLine: address.addressLine
        }
      };
      if (oneAddress) {
        params.parcelId = localStorage.getItem(
          "exchange-milk-plan-one-parcelId"
        );
      } else {
        params.status = 1;
      }
      this.updatePlanAddress(params);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //tabBar透明度
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let detTo = this.$refs.addDet.offsetTop;
      let opacity = top / 500;
      opacity = opacity > 1 ? 1 : opacity;
      this.bgStyle = { backgroundColor: "rgba(255,255,255," + opacity + ")" };
      this.opacityStyle = { opacity };
      this.opacityName = { opacity };
      if (top < detTo) {
        this.opacityStyle = {
          opacity: opacity
        };
      } else {
        this.bgStyle = { backgroundColor: "rgba(255,255,255,1)" };
        this.opacityStyle = {
          opacity: 1
        };
      }
    },
    // getDistributionPlan
    getData() {
      const params = {
        subOrderSn: this.$route.query.subOrderSn
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/getDistributionPlan", { params })
        .then(() => {
          localStorage.removeItem("mall-wap-milkplan-choosedate");
        })
        .catch(() => {
          localStorage.removeItem("mall-wap-milkplan-choosedate");
        });
    },
    // updateDistributionPlanPlanDeliveredAt
    updatePlan(params) {
      this.$store
        .dispatch("order/updateDistributionPlanPlanDeliveredAt", { params })
        .then(() => {
          if (params.status === 1) {
            this.$toast("暂停配送成功");
          } else if (params.status === 0) {
            this.$toast("恢复配送成功");
          } else {
            this.$toast("日期修改成功");
          }
          this.getData();
          localStorage.removeItem("mall-wap-milkplan-choosedate");
        })
        .catch(() => {});
    },
    // updateDistributionPlanAddress
    updatePlanAddress(params) {
      this.$store
        .dispatch("order/updateDistributionPlanAddress", { params })
        .then(() => {
          this.$toast("地址修改成功");
          setTimeout(() => {
            this.getData();
            localStorage.removeItem("exchange-milk-plan-one-parcelId");
            localStorage.removeItem("exchange-milk-plan-one-address");
            localStorage.removeItem("exchange-milk-plan-all-address");
          }, 500);
        })
        .catch(err => {
          this.$toast(err.message);
          setTimeout(() => {
            // this.getData();
            localStorage.removeItem("exchange-milk-plan-one-parcelId");
            localStorage.removeItem("exchange-milk-plan-one-address");
            localStorage.removeItem("exchange-milk-plan-all-address");
          }, 1000);
        });
    },
    back() {
      this.$router.back();
      localStorage.removeItem("mall-wap-milkplan-choosedate");
    },
    lookLogist(trackingNo) {
      this.$router.push({
        path: "/order/detail/logistics",
        query: {
          purPage: "milkplan",
          trackingNo
        }
      });
    },
    // 暂停配送
    stopDate() {
      this.$dialog
        .confirm({
          // title: "暂停配送",
          message: "鲜奶暂停配送，仅可暂停一个月，一个月后自动恢复配送",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          const params = {
            subOrderSn: this.$route.query.subOrderSn,
            status: 1
          };
          this.updatePlan(params);
        })
        .catch(() => {});
    },
    // 恢复配送
    containDate() {
      this.$dialog
        .confirm({
          // title: "恢复配送",
          message:
            "恢复配送后，鲜奶将会在最近的周期进行配送。如需调整配送时间，可以在恢复后，进行顺延修改",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          const params = {
            subOrderSn: this.$route.query.subOrderSn,
            status: 0
          };
          this.updatePlan(params);
        })
        .catch(() => {});
    },
    modifyAddress(id) {
      this.modifyOnePacel = id;
      // console.log("修改地址");
      this.show = true;
    },
    goAddressList(key) {
      this.show = false;
      // console.log("点击期数修改地址" + key);
      this.$router.push({
        path: "/mine/addresslist",
        query: {
          switchPur: key,
          previousPage: "milkPlan",
          parcelId: this.modifyOnePacel
        }
      });
    },
    // 地址弹窗
    closeBg() {
      this.show = false;
    },
    // 日期选择
    goChooseDate() {
      this.$router.push({
        path: "/order/choosedate",
        query: {
          deliveryPlanTime: this.getDistributionPlan.currentAvailableTime,
          totalPeriods: this.getDistributionPlan.totalPeriods,
          periodInterval: this.getDistributionPlan.periodInterval,
          defaultPlanTime: this.showEditBtn[0].planDeliveredAt
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.order_detail {
  z-index: 1;
  ::v-deep .van-overlay {
    z-index: 1000;
  }
  .det_none_btn {
    height: 85px;
  }
  .det_mar {
    height: 115px;
  }
  .det_mar1 {
    height: 12px;
  }
  .detail_con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    margin: 0 12px;
    .bar_header {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      padding-right: 36px;
      z-index: 99;
      .icon_back {
        width: 24px;
        margin: 12px 0 0 12px;
        z-index: 100;
      }
    }
  }

  .header_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
  }
  .top_address {
    margin-top: 12px;
  }
  .product_con_det {
    margin: 12px 0 0;
    background: #fff;
  }
  .plan_det {
    margin-top: 12px;
    border-radius: 6px;
    background: #fff;
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    background: #fff;
    z-index: 99;
  }
}
</style>
